import { Component, ViewEncapsulation, Input, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { Elemento } from 'app/domain/elementos';
import { LocalStorageService } from 'app/services/local-storage.service';
import { global } from 'app/utils/global';

@Component({
    selector     : 'quick-panel',
    templateUrl  : './quick-panel.component.html',
    styleUrls    : ['./quick-panel.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuickPanelComponent implements AfterViewChecked
{   
    date: Date;
    fechaStr: string;
    dia: string;
    options = { month: 'long', day: 'numeric',  year: 'numeric'};
    optionsD = { weekday: 'long'};
    events: any[];
    notes: any[];
    settings: any;

    itemsTotalizados: Array<Elemento>;

    main2: any;

    /** 
     * Constructor
     */
    constructor(private localStorageService: LocalStorageService,
        private cdRef: ChangeDetectorRef)
    {
        // Set the defaults
        this.date = new Date();
        this.fechaStr = this.date.toLocaleDateString("es-ES", this.options);
        this.dia = this.date.toLocaleDateString("es-ES", this.optionsD).toLocaleUpperCase();
        // this.date.toLocaleDateString("es-ES", this.options);

        this.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

    }

    ngAfterViewChecked() {
       this.itemsTotalizados = this.localStorageService.get(global.SESSION_ITEMS.ITEMS_MENU_DERECHO);
       this.cdRef.detectChanges();
    }
    
}
